import { useSearchParam } from 'react-use';

import { PagePaths, PageTitles } from '@revelio/core';

import {
  APP_PAGE_TYPE,
  usePageVisitTracking,
} from '../../hooks/usePageVisitTracking';
import DashboardPage from '../DashboardPage';
import { ReportIframe } from './components/report-iframe';
import styles from './sample-report.page.module.css';

const getSampleReportId = (link: string | null): string | undefined => {
  if (!link) return undefined;
  try {
    return new URL(link).searchParams.get('id') ?? undefined;
  } catch {
    return undefined;
  }
};

const SampleReportPage = () => {
  const link = useSearchParam('link');
  const sampleLink = link && decodeURIComponent(link);
  const title = [PageTitles.REPORTS_SAMPLE];
  usePageVisitTracking({
    page: title.join('/'),
    pageId: PagePaths.REPORTS_SAMPLE,
    pageType: APP_PAGE_TYPE,
    visitProperties: { sampleLink, report_id: getSampleReportId(sampleLink) },
  });

  if (!sampleLink) {
    return (
      <div className={styles.notFound}>
        Sorry, we could not find this resource.
      </div>
    );
  }

  return (
    <DashboardPage title={title} loading={false}>
      <ReportIframe link={sampleLink} />
    </DashboardPage>
  );
};

export default SampleReportPage;
